import ChatEmpty from 'components/Svg/ChatEmpty';
import AnalogPhone from 'components/Svg/AnalogPhone';
import NewspageLogo from 'components/Svg/NewspageLogo';
import Settings from 'components/Svg/Settings';
import Book from 'components/Svg/Book';
import GraduationCap from 'components/Svg/GraduationCap';
import Quote from 'components/Svg/Quote2';
import Rss from 'components/Svg/Rss';
import ProfileIcon from 'components/Svg/Profile';
import Star from 'components/Svg/Star';
import Shield from 'components/Svg/Shield';
import styles from 'styles/modules/Nav.module.scss';

const navigationData = [
    {
        title: 'Home',
        url: '',
        icon: (color) => <NewspageLogo fill={color} />,
        company: true,
        journalist: false,
    },
    {
        title: 'Profile',
        url: '',
        icon: (color) => <ProfileIcon fill={color} />,
        company: false,
        journalist: true,
    },
    {
        title: 'Alerts',
        url: '/news-alerts',
        icon: (color) => <ChatEmpty stroke={color} />,
        company: true,
        journalist: true,
    },
    {
        title: 'Raws',
        url: '/raws',
        absolute: true,
        icon: (color) => <Book fill={color} />,
        company: true,
        journalist: true,
    },
    {
        title: 'Coverage',
        url: '/media-coverage',
        icon: (color) => <Quote fill={color} />,
        company: true,
        journalist: false,
    },
    {
        title: 'Upgrade',
        url: '/subscription',
        icon: () => (
            <div className={styles['upgrade-to-premium-item']}>
                <Star />
                <div className={[styles.ribbon].join()} />
            </div>
        ),
        company: true,
        journalist: false,
    },
    {
        title: 'Academy',
        url: '/academy',
        absolute: true,
        icon: (color) => <GraduationCap fill={color} />,
        company: true,
        // The guides are for business owners (Dominic, 22 Oct).
        journalist: false,
    },
    {
        title: 'Admin',
        url: '/admin',
        absolute: true,
        icon: (color) => <Shield fill={color} />,
        company: true,
        journalist: true,
        admin: true,
    },
    {
        title: 'Settings',
        url: '/settings',
        icon: (color) => <Settings fill={color} />,
        company: true,
        journalist: true,
    },
    {
        title: 'Breaking News',
        url: 'breaking-news',
        icon: (color) => <Rss fill={color} />,
        company: false,
        journalist: false,
    },
];

export default navigationData;
